import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import ViewInvoiceIcon from '@mui/icons-material/Description';
import OpenInvoiceIcon from '@mui/icons-material/LockOpen';
import { PathDataGrid } from '~common/components';
import PageTitle from '../../components/pageTitle';

import OpenDraftInvoicesDialog from './components/openDraftInvoicesDialog';
import ReviewInvoiceDialog from './components/reviewInvoiceDialog';
import useTutorInvoices from './hooks/useTutorInvoices';
import useStyles from './styles';
import columns from './columns';

function TutorInvoices() {
  const { classes } = useStyles();
  const {
    invoices,
    loading,
    error,
    alert,
    selectedInvoice,
    selectionModel,
    canOpenDraftInvoices,
    showOpenDraftInvoicesDialog,
    openingDraftInvoices,
    openDraftInvoicesResult,
    onSelectionModelChange,
    onRefreshClick,
    onReviewInvoiceClick,
    onReviewInvoiceDailogClose,
    onReviewInvoiceDialogSubmit,
    onOpenDraftInvoicesClick,
    onOpenDraftInvoicesDialogClose,
    onOpenDraftInvoicesDialogSubmit,
    showReviewInvoiceDailog,
  } = useTutorInvoices();

  const toolbarActions = [
    ...(canOpenDraftInvoices ? [{
      id: 'open-draft-invoices',
      label: 'Open Draft Invoices',
      startIcon: <OpenInvoiceIcon />,
      onClick: onOpenDraftInvoicesClick,
    }] : []),
    {
      id: 'review-invoice',
      label: 'Review Invoice',
      startIcon: <ViewInvoiceIcon />,
      disabled: !selectedInvoice,
      onClick: onReviewInvoiceClick,
    },
  ];

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <PageTitle title="Tutor Invoices" />
      </div>
      <div className={classes.content}>
        <Grid container className={classes.grid}>
          <Grid item xs={12} className={classes.gridItem}>
            <Paper className={classes.background}>
              {error && <Alert severity="error" className={classes.alert}>{error}</Alert>}
              {alert && (
                <Alert severity={alert.severity} className={classes.alert}>
                  {alert.message}
                </Alert>
              )}
              <PathDataGrid
                className={classes.dataGrid}
                initialSorting={[{ id: 'createdAt', desc: true }]}
                loading={loading}
                rows={invoices}
                columns={columns}
                getRowId={(row) => row.id}
                onRefresh={onRefreshClick}
                toolbarActions={toolbarActions}
                showColumnFilters
                showColumnManager
                searchPlaceholder="Search..."
                onSelectionModelChange={onSelectionModelChange}
                selectionModel={selectionModel}
                pageSize={20}
                checkboxSelection={false}
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
      {showReviewInvoiceDailog && (
        <ReviewInvoiceDialog
          invoice={invoices.find((i) => i.id === selectedInvoice.id)}
          open={showReviewInvoiceDailog}
          onClose={onReviewInvoiceDailogClose}
          onCancel={onReviewInvoiceDailogClose}
          onSubmit={onReviewInvoiceDialogSubmit}
        />
      )}
      {showOpenDraftInvoicesDialog && (
        <OpenDraftInvoicesDialog
          open={showOpenDraftInvoicesDialog}
          loading={openingDraftInvoices}
          result={openDraftInvoicesResult}
          onClose={onOpenDraftInvoicesDialogClose}
          onSubmit={onOpenDraftInvoicesDialogSubmit}
        />
      )}
    </div>
  );
}

export default TutorInvoices;
